const FieldDepthProfile = () => {
  // declare utility functions
  const filterDates = util.setWaterYearDates();

  let depthProfileGraph;

  /**
   * Utility function used to resize the sidebars after each chart render
   */
  const resizeSidebar = () => {
    const $sidebar = document.querySelector("#annual-report-nav-wrapper");
    const $leftSection = document.querySelector(
      ".annual-report-monitoring-left-section"
    );
    const body = document.body;
    const html = document.documentElement;

    const height = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );

    console.log(height);

    $sidebar.style.height = `${height + 76}px`;
    $leftSection.style.height = `${height}px`;
  };

  const scales = {
    "3": {
      breaks: [11, 10, 9, 8, 7, 6, 5, 0],
      colors: [
        "#4e65ac",
        "#6869af",
        "#5ca7ba",
        "#addeac",
        "#e1f3aa",
        "#f6fbb5",
        "#ff9b93",
        "#e6665c",
      ],
      // breaks: [11, 10, 9, 8, 7, 6, 5],
      // colors: [
      //   "#4e65ac",
      //   "#6869af",
      //   "#5ca7ba",
      //   "#addeac",
      //   "#e1f3aa",
      //   "#f6fbb5",
      //   "#d45c53",
      // ],
    }, // DO
    "8": {
      breaks: [0, 5, 10, 15, 20, 26.2, 29.3, 29.3],
      colors: [
        "#4e65ac",
        "#6869af",
        "#5ca7ba",
        "#addeac",
        "#e1f3aa",
        "#f6fbb5",
        "#ff9b93",
        "#e6665c",
      ], 
    }, // Temp
    "7": {
      // breaks: [2.5,4,6.5,9,10.5,12,14], // old breaks
      breaks: [7, 7.5, 8, 8.5, 9, 9.5, 10], 
      colors: ['#4E65AC', '#6869AF', '#5CA7BA', '#ADDEAC', '#F6FBB5', '#FF9B93', '#E6665C'],
    }, // pH
  };
  const StartDate = new datePicker({
    container: "#start-date",
    elementExists: true,
    onChange: () => {
      createResultRequest(
        StartDate.getDate(),
        EndDate.getDate(),
        location.val(),
        parameter.val()
      );
    },
  }).setDate(filterDates[0]);

  const EndDate = new datePicker({
    container: "#end-date",
    elementExists: true,
    onChange: () => {
      createResultRequest(
        StartDate.getDate(),
        EndDate.getDate(),
        location.val(),
        parameter.val()
      );
    },
  }).setDate(filterDates[1]);

  const parameter = new Dropdown({
    container: "#parameter",
    elementExists: true,
    onChange: () => {
      createResultRequest(
        StartDate.getDate(),
        EndDate.getDate(),
        location.val(),
        parameter.val()
      );
    },
  }).val(3);

  const location = new Dropdown({
    container: "#location",
    elementExists: true,
    onChange: () => {
      createResultRequest(
        StartDate.getDate(),
        EndDate.getDate(),
        location.val(),
        parameter.val()
      );
    },
  }).val(80);

  // Create an async function as a shorthand for resolving fetch requests
  async function fetchData(url) {
    let response = await fetch(url);
    let json = await response.json();
    return json;
  }

  function createResultRequest(startDate, endDate, loc, param) {
    const resultsPromise = fetchData(
      `/sites/all/scripts/view/depth-profile.php?table=viewer.depth_profile_graph_data&fields%5B%5D=rdate&fields%5B%5D=*&location=${loc}&parameter=${param}&sort=rdate,depth_value`
    );

    resultsPromise.then(data => {
      const filteredData = data.filter(d => {
        return (
          new Date(`${startDate} 00:00:00`).getTime() <=
          new Date(d.rdate).getTime() &&
          new Date(`${endDate} 00:00:00`).getTime() >=
          new Date(d.rdate).getTime()
        );
      });

      if (filteredData.length > 0) {
        const formattedData = filteredData.map(d => {
          return {
            rdate: d.rdate,
            depth_value: parseInt(d.depth_value),
            rvalue: +d.rvalue_converted,
            unit_name: d.unit_name,
            parameterid: d.parameterid,
          };
        });
        depthProfileGraph.scale = scales[param];
        depthProfileGraph.setData(formattedData);
        depthProfileGraph.draw();
        setTimeout(resizeSidebar, 1000);
      } else {
        depthProfileGraph.removeSVG(
          '<h4 class="text-center">No data returned for the current selections. Please update the filters and try again</h4>'
        );
      }
    });
  }

  const resultsPromise = fetchData(
    "/sites/all/scripts/view/depth-profile.php?table=viewer.depth_profile_graph_data&fields%5B%5D=rdate&fields%5B%5D=*&location=80&parameter=3&sort=rdate,depth_value"
  );

  // Request initial data from the DB
  resultsPromise.then(data => {
    const filteredData = data.filter(d => {
      return (
        new Date(`${filterDates[0]} 00:00:00`).getTime() <=
        new Date(d.rdate).getTime() &&
        new Date(`${filterDates[1]} 00:00:00`).getTime() >=
        new Date(d.rdate).getTime()
      );
    });

    depthProfileGraph = new Heatmap({
      container: "#depth-profile-chart",
      data: [],
      xAxis: {
        enabled: true,
      },
      scale: scales["3"],
      legend: { itemWidth: 65 },
    });

    if (filteredData.length > 0) {
      const formattedData = filteredData.map(d => {
        return {
          rdate: d.rdate,
          depth_value: d.depth_value,
          rvalue: +d.rvalue_converted,
          unit_name: d.unit_name,
          parameterid: d.parameterid,
        };
      });

      depthProfileGraph.scale = scales["3"];
      depthProfileGraph.setData(formattedData);
      depthProfileGraph.draw();
    } else {
      document.querySelector("#depth-profile-chart").innerHTML = `
        <h4 class="text-center">
          No data returned for the current selections. Please update the filters and try again
        </h4>
      `;
    }
  });
};
